import { captureException } from "@sentry/browser";
import type { LoaderFunction } from "react-router-dom";
import { api, type ApiError } from "../api/ApiClient";
import {
  type AccidentReportViewModel,
  VehicleKey,
} from "#accident-statement/schema";
import type { UnauthorizedReportErrorResult } from "./auth/UnauthorizedReportErrorResult";

export interface LoadedReport {
  report: AccidentReportViewModel;
  party: VehicleKey;
}

export type ReportLoaderResult =
  | { loaded: LoadedReport }
  | { unauthorized: UnauthorizedReportErrorResult };

export const reportLoader: LoaderFunction = async ({
  request,
}): Promise<null | ReportLoaderResult> => {
  if (typeof window === "undefined") return null;
  const token = new URL(request.url).searchParams.get("token");
  if (!token) return null;

  try {
    const report = await api.get<AccidentReportViewModel>(
      `report/token/${token}`,
    );
    const party = report && "tokenA" in report ? VehicleKey.A : VehicleKey.B;
    return { loaded: { report, party } };
  } catch (error: unknown) {
    console.log({ error });
    const apiError = error as ApiError;
    if (apiError.status === 401) {
      const unauthorizedResult =
        apiError.result as UnauthorizedReportErrorResult;
      return { unauthorized: unauthorizedResult };
    }
    captureException(apiError);
    throw new Error("Failed to fetch report");
  }
};
reportLoader.hydrate = false;
